import { TranRecordModel } from "./tran-record.model"

export class HandleInvtModel {
    lngClientNo: number
    lngPetNo: number
    intCodeNo: number
    strStatus: string
    strReqEmp: string
    intEmpNo: number
    strFix: string
    Trans: TranRecordModel[]
    intTotalIdx: number
    intIndex: number
    strCodeName: string
    lngSupSeq: number
    strLinkSaleTreat: string
    sglLinkUnit: number
    intClinicNo: number
 

    constructor(
        lngClientNo: number,
        lngPetNo: number,
        intCodeNo: number,
        strStatus: string,
        strReqEmp: string,
        intEmpNo: number,
        strFix: string,
        Trans: TranRecordModel[],
        intTotalIdx: number,
        intIndex: number,
        strCodeName: string,
        lngSupSeq: number,
        strLinkSaleTreat: string,
        sglLinkUnit: number,
        intClinicNo: number,
    ) {
        this.lngClientNo = lngClientNo
        this.lngPetNo = lngPetNo
        this.intCodeNo = intCodeNo
        this.strStatus = strStatus
        this.strReqEmp = strReqEmp
        this.intEmpNo = intEmpNo
        this.strFix = strFix
        this.Trans = Trans
        this.intTotalIdx = intTotalIdx
        this.intIndex = intIndex
        this.strCodeName = strCodeName
        this.lngSupSeq = lngSupSeq
        this.strLinkSaleTreat = strLinkSaleTreat
        this.sglLinkUnit = sglLinkUnit
        this.intClinicNo = intClinicNo
    }
}